/* eslint-disable */
<template>

        <div class="add-product-box">
          <p>Neue 10-stellige Artikelnummer:</p>
          <div class="overlay-formfield"><span class="countDigits" v-if="countDigits < 10 ">+ {{ 10 - countDigits }}</span> <input v-model="newproduct" ref="artno" maxlength="10" v-on:keyup="checkArtNo" :class=" newproducterror ? 'bad' : 'good' ">
             <span class="newproductDouble" v-if="newproductDouble">Ein Produkt mit dieser Artikelnummer ist bereits angelegt!</span></div>
              <p><button v-on:click="addProductSave">Produkt anlegen</button></p>
        </div>

</template>
<script>
//import config from '../_config/config';

export default {
  name: 'AddProduct',
  props: ['products'],
  data () {
    return {
        newproduct: '',
        newproducterror: '',
        countDigits: 0,
        newproductDouble: false,
    }
  },
  computed: {
    /*
          projects () {
              return this.$store.state.projects.all
            },
    */
      },
    created(){
         // this.config = config
         console.log('overlay created');
      },
    methods: {
          checkArtNo(e){
                  //this.newproducterror = this.newproduct.length != 10 
                  this.countDigits = this.newproduct.length;
                  
                  console.log( this.products.filter((p) => {
                        return ( p.articlenumber && p.articlenumber.indexOf(this.newproduct) > -1 )
                      }).length > 0 && this.newproduct.length == 10 );

                 this.newproductDouble = this.newproduct.length == 10 && this.products.filter((p) => {
                    return ( p.articlenumber && p.articlenumber.indexOf(this.newproduct) > -1 )
                  }).length  > 0;

                  this.newproducterror =  this.newproduct.length < 10  || this.newproductDouble;
                  
                  //console.log( this.$refs.artno );
                  this.$nextTick( () => this.$refs.artno.focus());

            },
            addProductSave(){

              if( this.newproduct.length != 10 || this.newproductDouble !== false ) { this.newproducterror = true; return false }

              this.submitted = true;
              const { id, articlenumber, attributes } = { id: null, articlenumber: this.newproduct, attributes: {} };
              const { dispatch } = this.$store;
              if (articlenumber && attributes) {
                  dispatch('products/save', { id, articlenumber, attributes })
                    .then( (res ) => {
                        if( res.last_insert_id > 0)
                        this.openOverlayAddproduct = false;
                        this.$router.push('/manager/product/' + this.newproduct );
                        //this.id = this.getSavedProduct.last_insert_id
                    });
              }
        },

      },
}
</script>
<style scoped>
    .add-product-box .overlay-formfield { position: relative; width: 20rem; margin: 0 auto; padding: 0; font-size: 1.411rem; padding-bottom: 1rem; }
    .add-product-box .overlay-formfield input { width: 100%; box-shadow: 0 0 0px 1px rgba(255,255,255,0.9); border-radius: 0; }
    .newproductDouble { background: #dc1200; padding: 0.4333rem 1rem; color: #fff; display: block; margin: 2px 0 0.333rem 0; font-size: 1rem; }
    .countDigits { position: absolute; top: 0.84333rem; right: 0.7333rem; color: #777; }
</style>